/*
  Daryada — filtres de collection.
  Chaque choix recharge la page filtrée (filtrage natif de Shopify) : pas
  de logique maison, et la page reste utilisable sans JavaScript.
*/
(() => {
  const form = document.querySelector('[data-filtres]');
  if (!form) return;

  const submit = () => {
    // Champs de prix vides : on ne les envoie pas
    form.querySelectorAll('[data-filtre-prix]').forEach((input) => {
      input.disabled = input.value === '';
    });
    form.submit();
  };

  form.addEventListener('change', (event) => {
    if (event.target.matches('[data-filtre-prix]')) return;
    submit();
  });

  // Prix : validation à la sortie du champ ou avec Entrée
  form.querySelectorAll('[data-filtre-prix]').forEach((input) => {
    input.addEventListener('change', submit);
  });

  // Un seul panneau de filtre ouvert à la fois ; clic à l'extérieur = fermeture
  const panels = [...form.querySelectorAll('[data-filtre]')];
  panels.forEach((panel) => {
    panel.addEventListener('toggle', () => {
      if (!panel.open) return;
      panels.forEach((other) => {
        if (other !== panel) other.open = false;
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-filtre]')) panels.forEach((panel) => (panel.open = false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = panels.find((panel) => panel.open);
    if (open) {
      open.open = false;
      open.querySelector('summary').focus();
    }
  });
})();
